import {
    fromUnixTime,
    isAfter,
    isBefore,
    isFuture,
    secondsToMilliseconds,
} from 'date-fns';

import {
    EpgProgram,
    MixedItem,
    RBProgram,
} from 'store/railsBuilder/reducer.types';
import { RecordingMetadata } from 'store/recordings/reducer.types';

import { VodEditorial } from 'services/data-manager/types';

import getCorrectProgramStartAndEndTime from 'utils/getCorrectProgramStartAndEndTime';

export function isLive(
    program:
        | EpgProgram
        | RBProgram
        | MixedItem
        | VodEditorial
        | RecordingMetadata
        | null
        | undefined,
) {
    if (program) {
        const { startTime, endTime } = program as MixedItem;
        const now = new Date();

        if (startTime && endTime) {
            return (
                isBefore(now, fromUnixTime(endTime)) &&
                isAfter(now, fromUnixTime(startTime))
            );
        }

        const { programStartTime, programEndTime } =
            getCorrectProgramStartAndEndTime(program);

        return !!(
            programEndTime &&
            programStartTime &&
            isBefore(now, fromUnixTime(programEndTime)) &&
            isAfter(now, fromUnixTime(programStartTime))
        );
    }

    return false;
}

export function isLiveEpgProgram(program: EpgProgram | null | undefined) {
    const now = new Date();

    return !!(
        program &&
        program.period.end &&
        program.period.start &&
        isBefore(now, secondsToMilliseconds(program.period.end)) &&
        isAfter(now, secondsToMilliseconds(program.period.start))
    );
}

export function isFutureProgram(btvProgram: RBProgram | undefined) {
    const { programStartTime } = getCorrectProgramStartAndEndTime(btvProgram);

    return !!(
        programStartTime && isFuture(secondsToMilliseconds(programStartTime))
    );
}
